var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "策略详情",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.formData,
            "label-width": "80px",
            inline: "",
            size: "small",
            disabled: "",
          },
        },
        [
          _c(
            "el-card",
            {
              attrs: { shadow: "never" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("基础信息"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "业务类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.formData.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "type", $$v)
                              },
                              expression: "formData.type",
                            },
                          },
                          _vm._l(_vm.tacticsTypeOptions, function (item) {
                            return _c(
                              "el-option",
                              _vm._b(
                                { key: item.value },
                                "el-option",
                                item,
                                false
                              )
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "策略名称", prop: "name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-card",
            {
              staticStyle: { "margin-top": "30px" },
              attrs: { shadow: "never" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("策略配置规则"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "title" }, [_vm._v("策略参数")]),
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.isShowSelectChannelInput,
                              callback: function ($$v) {
                                _vm.isShowSelectChannelInput = $$v
                              },
                              expression: "isShowSelectChannelInput",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("全部渠道"),
                            ]),
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("指定渠道"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _vm.isShowSelectChannelInput
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "指定渠道", prop: "appid" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "510px" },
                                  attrs: {
                                    type: "textarea",
                                    rows: 4,
                                    value: _vm.channelNameText,
                                  },
                                  on: {
                                    focus: function ($event) {
                                      _vm.isSelectChannel = true
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("策略结果")]),
                  _c("div", { staticClass: "subtitle" }, [
                    _vm._v("请选择符合上述参数条件时匹配的策略"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "结果类型" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.resultType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "resultType", $$v)
                                    },
                                    expression: "formData.resultType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("单一结果"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("流量权重"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v("次数限制"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.formData.configurationValue,
                        function (item, index) {
                          return [
                            _vm.formData.resultType === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    key: item,
                                    attrs: {
                                      label: "策略结果",
                                      prop: `configurationValue.${index}.id`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        key: index,
                                        model: {
                                          value:
                                            _vm.formData.configurationValue[
                                              index
                                            ].id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.configurationValue[
                                                index
                                              ],
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.configurationValue[index].id",
                                        },
                                      },
                                      _vm._l(
                                        _vm.tacticsResultOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            _vm._b(
                                              { key: item.value },
                                              "el-option",
                                              item,
                                              false
                                            )
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.formData.resultType === 2
                              ? _c(
                                  "div",
                                  { key: item },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "策略结果",
                                          prop: `configurationValue.${index}.id`,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            model: {
                                              value:
                                                _vm.formData.configurationValue[
                                                  index
                                                ].id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData
                                                    .configurationValue[index],
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.configurationValue[index].id",
                                            },
                                          },
                                          _vm._l(
                                            _vm.tacticsResultOptions,
                                            function (item) {
                                              return _c(
                                                "el-option",
                                                _vm._b(
                                                  { key: item.value },
                                                  "el-option",
                                                  item,
                                                  false
                                                )
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "权重",
                                          prop: `configurationValue.${index}.rate`,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              placeholder:
                                                "0- 100，不填表示100",
                                              min: "1",
                                              max: "100",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.configurationValue[
                                                  index
                                                ].rate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData
                                                    .configurationValue[index],
                                                  "rate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.configurationValue[index].rate",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("%"),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.formData.resultType === 3
                              ? _c(
                                  "div",
                                  { key: item },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "策略结果",
                                          prop: `configurationValue.${index}.id`,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            model: {
                                              value:
                                                _vm.formData.configurationValue[
                                                  index
                                                ].id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData
                                                    .configurationValue[index],
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.configurationValue[index].id",
                                            },
                                          },
                                          _vm._l(
                                            _vm.tacticsResultOptions,
                                            function (item) {
                                              return _c(
                                                "el-option",
                                                _vm._b(
                                                  { key: item.value },
                                                  "el-option",
                                                  item,
                                                  false
                                                )
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "次数/天",
                                          prop: `configurationValue.${index}.times`,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "1-999999" },
                                          model: {
                                            value:
                                              _vm.formData.configurationValue[
                                                index
                                              ].times,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.configurationValue[
                                                  index
                                                ],
                                                "times",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.configurationValue[index].times",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }